import { createFileRoute } from "@tanstack/react-router";
import { Globe2 } from "lucide-react";

export const Route = createFileRoute("/")({
  component: PortalHome,
});

function PortalHome() {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="max-w-md text-center space-y-3">
        <Globe2 className="size-10 mx-auto text-slate-400" />
        <h1 className="text-2xl font-medium">Actionary public portal</h1>
        <p className="text-sm text-slate-500">
          Forms, pages and gated assets published by tenants of the
          Actionary CRM. Visit a tenant&apos;s URL to interact with their
          surface.
        </p>
      </div>
    </div>
  );
}
